module.exports = __webpack_public_path__ + "img/style_8_pl.9ce9ff11.jpeg";